import React from 'react';
import { Check, Clock, Award, Heart, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import WhatsAppButton from '../../components/WhatsAppButton';
import { useNavigate } from 'react-router-dom';
import { useLanguage, getPageTexts } from '../../i18n/pageTranslations';

const QueEs = () => {
  const navigate = useNavigate();
  const lang = useLanguage();
  const t = getPageTexts('rinoQueEs', lang);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumb */}
      <div className="pt-24 pb-4 bg-cream">
        <div className="container mx-auto px-4">
          <button 
            onClick={() => navigate('/rinomodelacion')}
            className="flex items-center gap-2 text-gold hover:text-gold transition-colors"
          >
            <ArrowLeft size={20} />
            <span>{t.back}</span>
          </button>
        </div>
      </div>

      {/* Hero */}
      <section className="py-16 px-4 bg-gradient-to-b from-cream to-white">
        <div className="container mx-auto max-w-5xl text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-[#1C1C1A] mb-6">
            {t.title}
          </h1>
          <p className="text-xl text-text-secondary mb-8">
            {t.subtitle}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="prose max-w-none mb-12">
            <p className="text-lg text-text-secondary leading-relaxed mb-6" dangerouslySetInnerHTML={{ __html: t.desc1 }} />
            <p className="text-lg text-text-secondary leading-relaxed mb-6" dangerouslySetInnerHTML={{ __html: t.desc2 }} />
            <p className="text-lg text-text-secondary leading-relaxed mb-6">{t.desc3}</p>
          </div>

          {/* Ventajas */}
          <div className="bg-ivory p-8 rounded-none shadow-lg mb-12">
            <h2 className="text-3xl font-light text-[#1C1C1A] mb-8 text-center">
              {t.advantagesTitle}
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4 p-4 bg-cream rounded-none">
                <Clock className="text-gold mt-1 flex-shrink-0" size={32} />
                <div>
                  <h4 className="font-semibold text-[#1C1C1A] mb-2 text-lg">{t.adv1Title}</h4>
                  <p className="text-text-secondary">{t.adv1Desc}</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 p-4 bg-cream rounded-none">
                <Award className="text-gold mt-1 flex-shrink-0" size={32} />
                <div>
                  <h4 className="font-semibold text-[#1C1C1A] mb-2 text-lg">{t.adv2Title}</h4>
                  <p className="text-text-secondary">{t.adv2Desc}</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 p-4 bg-cream rounded-none">
                <Heart className="text-gold mt-1 flex-shrink-0" size={32} />
                <div>
                  <h4 className="font-semibold text-[#1C1C1A] mb-2 text-lg">{t.adv3Title}</h4>
                  <p className="text-text-secondary">{t.adv3Desc}</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 p-4 bg-cream rounded-none">
                <Check className="text-gold mt-1 flex-shrink-0" size={32} />
                <div>
                  <h4 className="font-semibold text-[#1C1C1A] mb-2 text-lg">{t.adv4Title}</h4>
                  <p className="text-text-secondary">{t.adv4Desc}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Qué puede corregir */}
          <div className="bg-gradient-to-r from-[#1C1C1A] to-[#1C1C1A] p-8 rounded-none text-white mb-12">
            <h3 className="text-2xl font-light mb-6 text-center">{t.correctionsTitle}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {t.corrections && t.corrections.map((correction, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Check className="text-teal-300 flex-shrink-0" size={24} />
                  <span>{correction}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <h3 className="text-2xl font-light text-[#1C1C1A] mb-4">{t.ctaTitle}</h3>
            <p className="text-text-secondary mb-6">{t.ctaDesc}</p>
            <Button 
              onClick={() => navigate('/rinomodelacion/contacto')}
              className="bg-gold hover:bg-gold text-white px-8 py-6 text-lg rounded-none"
            >
              {t.ctaButton}
            </Button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default QueEs;
